<template>
  <v-text-field
    v-bind="{
      ...$attrs,
      ...textFieldAttrs
    }"
    v-model="internalTextFieldValue"
    v-maska
    data-maska="##.##.####"
    @keydown.home="onHomePressed"
    @maska="onMaskaEvent"
  >
    <template #prepend-inner>
      <v-menu
        v-model="menu"
        v-bind="menuAttrs"
      >
        <template #activator="{ on: onMenu }">
          <v-icon
            v-on="onMenu"
          >
            {{ icons.mdiCalendar }}
          </v-icon>
        </template>
        <v-date-picker
          v-bind="datePickerAttrs"
          :value="internalDatePickerValue"
          @input="onDatePickerValueChanged"
        />
      </v-menu>
    </template>
  </v-text-field>


</template>
<script>
import {mdiCalendar} from '@mdi/js'
import {inputClass} from '@/mixins/input-class/input-class'
import {autocompleteOff} from '@/mixins/autocomplete-off/autocomplete-off'
import {DateTime} from 'luxon'
import XTextField from '@/components/x-env/text-field/XTextField.vue'
import {isEmpty} from '@/plugins/object-helpers'

/**
 * DatePicker-компонент.
 * (!) Используется библиотека Luxon
 */
export default {
  name: 'x-date-picker',
  components: {
    XTextField
  },
  mixins: [autocompleteOff, inputClass],
  props: {
    value: {
      type: String,
      default: null
    },
    menuProps: {
      type: Object,
      default: () => ({})
    },
    datePickerProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      icons: {
        mdiCalendar
      },
      menu: false,
      internalTextFieldValue: null,
      internalDatePickerValue: null
    }
  },
  computed: {
    /**
     * Атрибуты для компонента v-menu
     */
    menuAttrs() {
      return {
        closeOnContentClick: this.menuProps.closeOnContentClick ?? false,
        transition: this.menuProps.transition ?? 'scale-transition',
        offsetY: this.menuProps.offsetY ?? true,
        nudgeLeft: this.menuProps.nudgeLeft ?? 150,
        minWidth: this.menuProps.minWidth ?? 290,
        maxWidth: this.menuProps.maxWidth ?? 290
      }
    },

    /**
     * Атрибуты для v-text-field
     */
    textFieldAttrs() {
      return {
        autocomplete: this.attrAutocomplete,
        hideDetails: this.$attrs.hideDetails ?? 'auto',
        class: this.inputClass,
        outlined: this.$attrs.outlined ?? true,
        clearable: this.$attrs.clearable ?? true
      }
    },

    /**
     * Атрибуты для v-date-picker
     */
    datePickerAttrs() {
      return {
        color: this.datePickerProps.color ?? 'secondary',
        locale: this.datePickerProps.locale ?? 'ru-RU',
        noTitle: this.datePickerProps.noTitle ?? true,
        firstDayOfWeek: this.datePickerProps.firstDayOfWeek ?? 1,
        min: this.datePickerProps.min,
        max: this.datePickerProps.max
      }
    }
  },
  watch: {
    /**
     * Слушатель модели компонента
     * @param val значение в формате yyyy-MM-dd
     */
    value(val) {
      if (isEmpty(val)) {
        this.internalTextFieldValue = null
        this.internalDatePickerValue = null
        return
      }
      let luxonDateTime = DateTime.fromFormat(val, 'yyyy-MM-dd')
      if (luxonDateTime.isValid) {
        this.internalTextFieldValue = luxonDateTime.toFormat('dd.MM.yyyy')
        this.internalDatePickerValue = val
      } else {
        this.internalTextFieldValue = `${val.substring(8, 10)}.${val.substring(5, 7)}.${val.substring(0, 4)}`
        this.internalDatePickerValue = DateTime.now().toFormat('yyyy-MM-dd')
      }
    }
  },
  methods: {
    /**
     * Действия при изменении выбранного значения внутри v-date-picker
     */
    onDatePickerValueChanged(val) {
      this.$emit('input', val)
      this.internalDatePickerValue = val
      this.menu = false
    },

    /**
     * Действия при ручном вводе значения по маске
     * @param event событие от библиотеки maska
     */
    onMaskaEvent(event) {
      //Значение не введено - отправляем null
      if (isEmpty(event.detail.masked)) {
        this.$emit('input', null)
        return
      }

      //Ввод значения ещё не завершён
      if (!event.detail.completed) {
        return
      }

      //Ввод значения завершён - получаем немаскированное значение
      let value = event.detail.unmasked
      //Создаём объект luxon
      let luxonDateTime = DateTime.fromFormat(value, 'ddMMyyyy')
      //Если объект luxon сообщает о корректности - отправляем событие изменения даты
      if (luxonDateTime.isValid) {
        this.$emit('input', luxonDateTime.toFormat('yyyy-MM-dd'))
      } else {
        this.$emit('input', `${value.substring(4, 8)}-${value.substring(2, 4)}-${value.substring(0, 2)}`)
      }
    },

    /**
     * Действие при нажатии на клавишу Home в поле редактирования
     * @param event MouseEvent
     */
    onHomePressed(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.$emit('input', DateTime.now().toFormat('yyyy-MM-dd'))
      this.menu = false
    }
  }
}
</script>